import Gpt from "./Gpt";
import LazyAds from "./LazyAds";

// Needed for dynamic ad placements
window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];
window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];
window.__iasPET = window.__iasPET || {};
window.__iasPET.queue = window.__iasPET.queue || [];
window.__iasPET.pubId = process.env.IAS_ACCOUNT_ID;

const run = async () => {
  try {
    if (window.js_vars && window.js_vars.remove_ads) return $('.ad-leaderboard').remove() && null
    if (window.js_vars && window.js_vars.gdpr) return null

    Gpt.displayAds();

    LazyAds.startObservers();

    const gravityObserver = $.initialize(".has-gravity", ()=>{
      $(".gravity-ad-placeholder").insertAfter(".top-nav");
      gravityObserver.disconnect();
    })
  } catch {

  }
};

export default Object.freeze({ run });
